module.exports = __webpack_public_path__ + "media/images/redesign-images/misc/nav-image-01-1b022826a82301519191f1da2ddb8e86.webp";